// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';

const AddFinancialAccounts = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  
  // Configuration for Financial Account inputs
  const inputs = [
    {
      name: 'name',
      labelKey: 'Name',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'account_number',
      labelKey: 'AccountNumber',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'description',
      labelKey: 'Description',
      type: 'text',
      required: false,
      defaultValue: ''
    },
    {
      name: 'balance',
      labelKey: 'Balance',
      type: 'number',
      required: false,
      defaultValue: '0.00'
    }
  ];

  // Dropdowns configuration
  const dropdowns = [
    {
      name: 'organisation_id',
      labelKey: 'Organisation',
      required: true,
      defaultValue: '',
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name'
      }
    },
    {
      name: 'financial_account_type_id',
      labelKey: 'AccountType',
      required: true,
      defaultValue: '',
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-account-types`,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'type_en',
        labelKeyAr: 'type_ar'
      }
    },
    {
      name: 'parent_account_id',
      labelKey: 'ParentAccount',
      required: false,
      defaultValue: '',
      dependsOn: 'organisation_id',
      apiUrl: (formValues) => 
        `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts?organisation_id=${formValues.organisation_id}`,
      apiMethod: 'GET',
      dataPath: 'data.data.financialAccounts',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'name',
        labelKeyAr: 'name'
      },
      includeNoneOption: true,
      noneOptionLabelKey: 'MyAccount'
    }
  ];

  // Build the payload for financial account submission
  const buildSubmitPayload = (formValues) => {
    const payload = {
      name: formValues.name.trim(),
      account_number: formValues.account_number.trim(),
      description: formValues.description?.trim() || '',
      organisation_id: formValues.organisation_id,
      financial_account_type_id: formValues.financial_account_type_id,
      balance: formValues.balance || '0.00'
    };
    
    // Only include parent_account_id if it's selected and not empty
    if (formValues.parent_account_id && formValues.parent_account_id !== '') {
      payload.parent_account_id = formValues.parent_account_id;
    }
    
    return payload;
  };

  return (
    <AddEntity
      pageTitle="AddNewFinancialAccount"
      inputs={inputs}
      dropdowns={dropdowns}
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/settlements/financial-accounts`}
      buildSubmitPayload={buildSubmitPayload}
      backUrl="/settlements/FinancialAccounts/"
      successMessage="FinancialAccountAddedSuccessfully"
      addButtonLabel="Save"
      subsystemName="FinancialAccounts"
    />
  );
};

export default AddFinancialAccounts;
